module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stil-guides"
  }, [(_vm.isButton) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.isShowGuide = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-play"
  }), _vm._v(" Se guide til indberetningen\n  ")]) : _c('p', {
    staticClass: "text-link",
    on: {
      "click": function($event) {
        _vm.isShowGuide = true
      }
    }
  }, [_vm._v(_vm._s(_vm.textForLink))]), _vm._v(" "), (_vm.isShowGuide) ? _c('DModal', {
    attrs: {
      "isBgOverlay": true
    },
    on: {
      "close": function($event) {
        _vm.isShowGuide = false
      }
    }
  }, [_c('div', {
    staticClass: "d-embed",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-embed-container"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.videoLink,
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b1bd5b5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/StilGuides.vue
// module id = 2095
// module chunks = 1